export const EBI_API_BASE_URL = import.meta.env.VITE_EBI_API_BASE_URL;

export const DPS_API_BASE_URL = import.meta.env.VITE_DPS_API_BASE_URL;

export const PUBLIC_API_BASE_URL = import.meta.env.VITE_PUBLIC_API_BASE_URL;

export const SWS_API_BASE_URL = import.meta.env.VITE_SWS_API_BASE_URL;

export const WS_API_BASE_URL = import.meta.env.VITE_WS_API_BASE_URL;

export const EBI_API_KEY = import.meta.env.VITE_EBI_API_KEY;

export const IS_PRODUCTION = import.meta.env.PROD;

export const IS_MOCK_API = import.meta.env.VITE_MOCK_API === "true";

export const TG_ANALYTICS_TOKEN = import.meta.env.VITE_TG_ANALYTICS_TOKEN;

export const TG_ANALYTICS_APP_NAME = import.meta.env.VITE_TG_ANALYTICS_APP_NAME;

export const POSITIONS_RE_FETCH_INTERVAL = 2000;

export const ORDER_HISTORY_RE_FETCH_INTERVAL = 2000;

export const MINUTE_IN_MS = 1000 * 60;

export const HOUR_IN_MS = MINUTE_IN_MS * 60;

export const DAY_IN_MS = HOUR_IN_MS * 24;

export const INVITE_SHARE_URL = "https://t.me/fomo/app?startapp=ref_";

export const GTM_EVENTS = {
  AD_VISIBLE: "ad-visible",
  AD_CLICK: "ad-click",
};
